import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import NextButton from '~/components/shared/Stepper/components/NextButton';
import { ApiStatus } from '~/store/types/sharedTypes';
import { RootState } from '~/store';
import useSubmit from '../../Steps/useSubmit';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';

export const UploadDocumentsFooter = () => {
  const {
    loanApplication: { form, apiStatus },
  } = useSelector((state: RootState) => state);

  const dispatch = useAppDispatch();
  const onSubmit = useSubmit();

  const onSubmitButtonClick = () => {
    const actionName = form.bankFilesUploaded
      ? 'click_submit_application_button'
      : 'click_skip_upload_documents_and_submit_application_button';

    dispatch(pushToGtmLoanAction({ actionName }));

    onSubmit();
  };

  return (
    <NextButton
      label={
        form.bankFilesUploaded
          ? 'Onboarding.Submit'
          : 'Onboarding.SkipAndSubmit'
      }
      isLoading={apiStatus.patch === ApiStatus.Started}
      action={onSubmitButtonClick}
    />
  );
};
